<template>
  <div
    class="modalMask"
    v-if="visible"
    @click.self="handleClickOutside"
    @touchmove.prevent
  >
    <transition
      name="slide-in"
      @after-enter="handleModalEnter"
      @touchmove.prevent
    >
      <div class="container" v-show="isShowModalContent">
        <img
          class="firework"
          v-if="scatteringVisible && showFirework"
          :src="scatteringImg"
        />
        <img
          v-if="showFirework"
          class="bgLight"
          src="../assets/images/modal-light.png"
        />
        <div class="header" :class="headerType"></div>
        <div class="closeBtn" @click="handleClickClose"></div>
        <div class="contentContainer">
          <slot></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ScatteringImg from '../assets/images/scattering.png';

export default {
  data() {
    return {
      isShowModalContent: false,
      scatteringVisible: false
    };
  },
  props: {
    showFirework: {
      type: Boolean,
      default: false
    },
    headerType: {
      required: true,
      validator: function(value) {
        return ['win', 'fail'].indexOf(value) !== -1;
      }
    },
    visible: {
      type: Boolean,
      default: false
    },
    closeable: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    visible: function(newVal, oldVal) {
      if (newVal && !oldVal) {
        setTimeout(() => {
          this.isShowModalContent = true;
        }, 10);
      }
      if (!newVal && oldVal) {
        this.isShowModalContent = false;
      }
    }
  },
  computed: {
    scatteringImg() {
      return this.scatteringVisible ? ScatteringImg + '?t=' + Date.now() : '';
    }
  },
  methods: {
    handleClickOutside() {
      this.closeable && this.$emit('close');
    },
    handleClickClose() {
      this.$emit('close');
    },
    handleModalEnter() {
      this.scatteringVisible = true;
      setTimeout(() => {
        this.scatteringVisible = false;
      }, 600);
    }
  }
};
</script>

<style lang="less" scoped>
.modalMask {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 9;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.88);

  .container {
    position: relative;
    width: 582px;
    min-height: 200px;
    border-radius: 20px;
    background: #fff;

    &.slide-in-enter {
      transform: translateY(-600px);
    }

    &.slide-in-enter-active {
      transition: transform 0.1s linear;
    }

    .firework {
      position: absolute;
      left: 50%;
      z-index: -1;
      transform: translateX(-50%);
      bottom: 100%;
      width: 746px;
      height: 426px;
    }

    .bgLight {
      position: absolute;
      left: 50%;
      z-index: -1;
      margin-left: -350px;
      top: -320px;
      width: 700px;
      height: 700px;
      transform-origin: center;
      animation: lightRotation 10s linear infinite;
    }

    .header {
      position: absolute;
      top: -102px;
      left: 50%;
      transform: translateX(-50%);
      width: 553px;
      height: 171px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;

      &.win {
        background-image: url('../assets/images/modal-header-win.png');
      }
    }

    .closeBtn {
      position: absolute;
      top: -110px;
      right: -25px;
      width: 60px;
      height: 60px;
      background: center / cover no-repeat url('../assets/images/close-btn.png');
    }

    .contentContainer {
      padding-top: 70px;
    }
  }
}
@keyframes lightRotation {
  form {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
